import type { FindingVerdict } from "../../hooks/useReviewerFindingVerdicts";

/** Chip tint class for a reviewer verdict, or null for pending/none. Monochrome
 *  design system: agree=signal, disagree=warn, skip=muted; agree vs disagree are
 *  ALSO distinguished by the ✓/✕ badge, not hue alone (one-accent contract). */
export function verdictChipClass(verdict: FindingVerdict | undefined): string | null {
  switch (verdict) {
    case "agree":
      return "verdict-agree";
    case "disagree":
      return "verdict-disagree";
    case "skip":
      return "verdict-skip";
    default:
      return null;
  }
}

export function verdictBadgeText(verdict: FindingVerdict | undefined): string | null {
  switch (verdict) {
    case "agree":
      return "✓";
    case "disagree":
      return "✕";
    case "skip":
      return "–";
    default:
      return null;
  }
}
